import * as Stimulus from "@hotwired/stimulus"

export class FieldsetController extends Stimulus.Controller {
    static targets = [ 'input', 'errorDisplay' ]
    static classes = [ 'error' ]

    validateInputs(e) {
        for(const $target of this.inputTargets) {
            const targetEvent = this.dispatch("validate", { target: $target });
            if(targetEvent.defaultPrevented) {
                e.preventDefault();
                return;
            }
        }
    }

    clearValidationError() {
        for (const $target of this.inputTargets) {
            $target.classList.remove(...this.errorClasses);
        }
        this.errorDisplayTarget.innerText = '';
    }

    displayValidationError(e) {
        for (const $target of this.inputTargets) {
            $target.classList.add(...this.errorClasses);
        }
        this.errorDisplayTarget.innerText = e.detail.errorMessage;
    }

}
